import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Tooltip } from '@reveni-io/reveni-ui'

import { getErrorCountKey } from '@/configuration/helpers/helpers'

import { countLayoutErrors } from '../hooks/useBlockErrors/helpers'
import LayoutErrorsTooltip from './LayoutErrorsTooltip/LayoutErrorsTooltip'
import { getLayoutErrorRows } from './helpers'
import * as Styles from './styles'

const LayoutErrorsChip = ({ layout, layoutErrors, blockSettings, onNavigateToBlock }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const errorCount = countLayoutErrors(layoutErrors)
  const rows = getLayoutErrorRows({ layout, layoutErrors, blockSettings, t })

  return (
    <Tooltip title={<LayoutErrorsTooltip rows={rows} onNavigateToBlock={onNavigateToBlock} />}>
      <Styles.ChipWrapper>
        <Chip
          label={t(getErrorCountKey(errorCount), { count: errorCount })}
          Icon={WarningIcon}
          backgroundColor={theme.colors.danger.surface}
          color={theme.colors.danger.onSurface}
        />
      </Styles.ChipWrapper>
    </Tooltip>
  )
}

export default LayoutErrorsChip
